export default __webpack_public_path__ + "static/media/newthree.124f49e7.png";